import { useApiQuery } from '../useApiQuery'
import * as api from '../api'
import { z } from 'zod'
import { ReturnsUserBookedLearningItems } from '../useInvalidate'

export default function useUserBookedLearningItems(
  userUuid: string,
  learningItemsUuids: string[],
  managerUuid: string | undefined
) {
  const { data, ...result } = useApiQuery({
    enabled: learningItemsUuids.length > 0 && !!managerUuid,
    queryKey: ['userBookedLearningItems', ReturnsUserBookedLearningItems],
    placeholderData: (previousData) => previousData || [],
    queryFn: async () => {
      const response = await api.post(
        `user/${encodeURIComponent(userUuid)}/bookings-for-learning-items/${managerUuid}`,
        {
          uuids: learningItemsUuids,
        }
      )

      return z
        .array(
          z.object({
            learningItemUuid: z.string().uuid(),
            bookedEventUuid: z.string().uuid(),
            // The course can be assigned to the user by more than one group. This
            // flag is TRUE if the course is assigned to the user by a group
            // that provided managerUuid is not a manager of.
            hasOtherGroupsAssignmentsThanFromProvidedManager: z.boolean(),
          })
        )
        .parse(response)
    },
  })

  return { userBookedLearningItems: data || [], ...result }
}
